// custom-validators.ts
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function noSpecialCharsValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value as string;
    const validNamePattern = /^[^{\}\(\)\[\]\+\*\?\^\$\|\\]*$/;
    const isValidName = validNamePattern.test(value);
    return isValidName ? null : { specialChars: true };
  };
}
